import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/content";

const WhatsAppFloat = () => {
  const message = encodeURIComponent(
    "Hello ADHD School, I would like to enquire about admission / therapy services.",
  );
  const href = `https://wa.me/${CONTACT.whatsappNumber}?text=${message}`;

  return (
    <a
      data-testid="whatsapp-float"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 grid place-items-center h-14 w-14 rounded-full shadow-xl transition-transform hover:scale-110"
      style={{ backgroundColor: "#25D366" }}
    >
      <MessageCircle size={26} className="text-white" />
      <span
        className="absolute -top-1 -right-1 h-3 w-3 rounded-full"
        style={{ backgroundColor: "#ff5252", boxShadow: "0 0 0 4px rgba(255,82,82,0.25)" }}
      />
    </a>
  );
};

export default WhatsAppFloat;
